import React from 'react';
import { 
	string, 
	func, 
	object ,
} from 'prop-types';
import {findAnswers,} from '../../../logics/questionBuilder';

class Container extends React.PureComponent {
	static propTypes = {
		editorProps:object,
		editText:string,
		render:func.isRequired,
	}

	constructor(props) {
		super(props);
		this.state = {
			selectedAnswerIndex:0,
		};
	}
	
	render(){
		const {editText,render,editorProps,...other} = this.props;
		const textArray = editText.split(/\r?\n/g);
		let answers = [];
		for(const text of textArray){
			const result = findAnswers(text);
			if(result.answers){
				answers = answers.concat(result.answers);
			} 
		}
		const previewProps = {
			editText,
			options:{},
			onClickAnswer:(idx)=>{
				this.setState({selectedAnswerIndex:idx});
			}
		};
		return render({
			previewProps,
			answers,
			editorProps,
		},other);
	}
}

export default Container;
